import { render, staticRenderFns } from "./newcomer-task-list.vue?vue&type=template&id=a8a811b4&scoped=true&lang=pug&"
import script from "./newcomer-task-list.vue?vue&type=script&lang=js&"
export * from "./newcomer-task-list.vue?vue&type=script&lang=js&"
import style0 from "./newcomer-task-list.vue?vue&type=style&index=0&id=a8a811b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a811b4",
  null
  
)

export default component.exports